import { object, string } from "yup";

const customerServiceSchema = object().shape({
  service_id: string()
    .required("Informe um serviço")
    .typeError("Selecione um serviço válido."),
});

export default customerServiceSchema;
